<template>
    <div class="grid grid-cols-3 gap-8 auto-rows-fr ">
        <div
            v-for="(product, index) in products"
            :key="index"
            class="flex flex-col "
        >
            <div class="flex-1">
                <h4 class="text-2xl font-semibold text-output-secondary">
                    {{ product.name }}
                </h4>
                <h5 class="text-sm font-semibold uppercase text-output-primary">
                    {{ product.type }}
                </h5>
            </div>
            <p class="flex-1 text-gray-700 ">
                {{ product.description }}
            </p>
            <hr class="w-11/12 h-1 mt-1 bg-output-secondary" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        products: {
            type: Array,
            required: true
        }
    }
};
</script>

<style></style>
